import NuCalBaseView from "./NuCalBaseView.js";
import {daysBetween,zeroPadNumber} from "../utils/General.js";
import Events from "../utils/Events.js";

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 */
class NuCalNumberOfNightsView extends NuCalBaseView {

	constructor(props){
		super(props);
		this.view.classList.add("cp-nuCalNumberOfNightsView");
		const lexi = this.lexicon.NuCalNumberOfNightsView;
		this.view.innerHTML = `
            <input type="hidden" name="${props.inputName}" id="${props.inputId}" class="cp-nuCalNumberOfNightsView-dateInput">
            <input class="cp-nuCalNumberOfNightsView-numberInput" type="number" min="1">
            <div class="cp-nuCalNumberOfNightsView-buttons">
                <button type="button" aria-label="${lexi.decrementButtonAria}" class="cp-nuCalNumberOfNightsView-button cp-nuCalNumberOfNightsView-button--decrement"></button>
                <button type="button" aria-label="${lexi.incrementButtonAria}" class="cp-nuCalNumberOfNightsView-button cp-nuCalNumberOfNightsView-button--increment"></button>
            </div>
        `;

		this._numberInput = this.view.querySelector(".cp-nuCalNumberOfNightsView-numberInput");
		this._dateInput = this.view.querySelector(".cp-nuCalNumberOfNightsView-dateInput");
		this._incrementButton = this.view.querySelector(".cp-nuCalNumberOfNightsView-button--increment");
		this._decrementButton = this.view.querySelector(".cp-nuCalNumberOfNightsView-button--decrement");

		this._numberInput.addEventListener("change", (e)=> { this.numberOfNights = e.target.value; });
		this._decrementButton.addEventListener("click", () => { this.decrement(); });
		this._incrementButton.addEventListener("click", () => { this.increment(); });
	}

	subscribe(){
		this._subscriptions.push(
			Events.subscribe( this._events.datesUpdated ,this.update.bind(this) )
		);
	}

	/**
     * Increase the number of nights by one.
     */
	increment(){
		this.numberOfNights += 1;
	}

	/**
     * Decrement the number of nights by one.
     */
	decrement(){
		this.numberOfNights -= 1;
	}

	/**
     * The number of nights. It will publish to the appropriate `NuCalController`.
     * @type {Number}.
    */
	get numberOfNights(){
		return parseInt(this._numberInput.value);
	}

	set numberOfNights(v){
		this._numberInput.value = parseInt(v);
		Events.publish(this._events.updateNumberOfNights,{ "numberOfNights": parseInt(v) });
	}

	update(props){
		this._arrivalDate = props.arrivalDate;
		this._departureDate = props.departureDate;
		this._numberInput.min = this._minNumberOfNights = props.minNumberOfNights;
		this._numberInput.max = this._maxNumberOfNights = props.maxNumberOfNights;
		this._incrementButton.disabled = !(this._numberInput.value < this._maxNumberOfNights);
		this._decrementButton.disabled = !(this._numberInput.value > this._minNumberOfNights);
		this._numberInput.value = daysBetween(this._arrivalDate,this._departureDate);
		this._dateInput.value = `${this._departureDate.getFullYear()}${zeroPadNumber(this._departureDate.getMonth()+1,2)}${zeroPadNumber(this._departureDate.getDate(),2)}`;
	}

}

export default NuCalNumberOfNightsView;